export default "__VITE_ASSET__CZZRSx4G__"